import { FileSearchOutlined } from '@ant-design/icons';
import React from 'react';
import { SonarMenuItem } from '@ui/menu';

import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';

export const impactAnalysisSubMenu: SonarMenuItem = {
	children: [
		{
			id: 'issues-menu-item',
			key: FULL_ROUTES.ISSUES,
			label: COPY_SPECIFIC.VALIDATION_RULE_ISSUES,
			route: FULL_ROUTES.ISSUES
		},
		{
			id: 'initiatives-menu-item',
			key: FULL_ROUTES.INITIATIVES,
			label: COPY_SPECIFIC.INITIATIVES,
			route: FULL_ROUTES.INITIATIVES
		}
	],
	icon: <FileSearchOutlined />,
	id: 'impact-analysis-submenu',
	key: 'impact-analysis',
	label: COPY_SPECIFIC.IMPACT_ANALYSIS
};
